// extracted by mini-css-extract-plugin
module.exports = {"root":"DiskNumber_root__2tWq5","icon":"DiskNumber_icon__1aOkq","disk":"DiskNumber_disk__3FimG"};